<template>
	<v-container fluid ma-0 pa-0>
	<v-toolbar flat color="blue-grey darken-1">
		<v-text-field v-model="filter" flat solo dense hide-details label="Suche" placeholder="Suche" background-color="blue-grey darken-2"	
			prepend-inner-icon="search" append-icon="mdi-keyboard-return"
			clearable clear-icon="mdi-close-circle-outline" @click:clear="onSearchClear()" @keyup.enter="onSearch()"
		></v-text-field>  
		<v-btn class="mx-1 mt-0" color="blue-grey darken-4" @click.stop="onSearch()">Suchen</v-btn>
		<v-spacer />
		<v-spacer />
		<v-btn :disabled="!cfgRefTable.cannew" color="blue-grey darken-4" @click.stop="onEditItem()">Neu</v-btn>
	</v-toolbar>
    <v-data-table
		:headers="cfgLists"
		:items="filteredItems"
		item-key="id"
		:page.sync="page"
		:items-per-page="perPage"
		must-sort
		:sort-by.sync="sortBy"
		:sort-desc.sync="sortDesc"
		:custom-sort="customSort"
		class="blue-grey darken-3 table-cursor"
		hide-default-footer
		:loading="loading"
		@click:row="onRowClick($event)"
    ><!---->
		<template v-for="cfgCol in cfgLists.filter((cfgCol) => cfgCol.format != 'default')"
			v-slot:[`item.${cfgCol.value}`]="{ value }">
			<span :key="cfgCol.id" :style="styleItem(value, cfgCol.format)">{{ formatItem(value, cfgCol.format) }}</span>
		</template>

		<template v-slot:[`item.id`]="{ item }">
			<v-chip color="blue-grey" dark x-small>{{ item.id }}</v-chip>
		</template>
		<template v-slot:[`item.action`]="{ item }">
			<v-hover v-if="cfgRefTable.actions.includes('edit')" v-slot:default="{ hover }">
			<v-btn small icon :color="`${hover? 'black': 'blue-grey'}`" :class="`${hover? 'success': 'blue-grey darken-3'}`" @click.stop="onEditItem(item.id)" :loading="false" :disabled="false">
				<v-icon>create</v-icon></v-btn></v-hover>
			<v-hover v-if="cfgRefTable.actions.includes('delete')" v-slot:default="{ hover }">
			<v-btn small icon :color="`${hover? 'black': 'blue-grey'}`" :class="`${hover? 'warning': 'blue-grey darken-3'}`" @click.stop="onDeleteItem(item.id)" :loading="false" :disabled="false">
				<v-icon small>delete</v-icon></v-btn></v-hover>
			<v-hover v-if="cfgRefTable.actions.includes('copy')" v-slot:default="{ hover }">
			<v-btn small icon :color="`${hover? 'black': 'blue-grey'}`" :class="`${hover? 'teal': 'blue-grey darken-3'}`" @click.stop="onCopyItem(item.id)" :loading="false" :disabled="false">
				<v-icon small>content_copy</v-icon></v-btn></v-hover>
			<v-hover v-if="cfgRefTable.actions.includes('cpyto') && !item.iscopied" v-slot:default="{ hover }">
			<v-btn small icon :color="`${hover? 'black': 'blue-grey'}`" :class="`${hover? 'teal': 'blue-grey darken-3'}`" @click.stop="onCopyItemTo(item.id)" :loading="false" :disabled="false">
				<v-icon small>content_copy</v-icon></v-btn></v-hover>
			<v-hover v-if="cfgRefTable.actions.includes('print')" v-slot:default="{ hover }">
			<v-btn small icon :color="`${hover? 'black': 'blue-grey'}`" :class="`${hover? 'primary': 'blue-grey darken-3'}`" @click.stop="onPrintItem(item.id)" :loading="false" :disabled="false">
				<v-icon small>print</v-icon></v-btn></v-hover>
		</template>
		<template slot="footer">
			<div class="text-xs-center pt-2">
				<v-pagination color="blue-grey" v-model="page" :length="pages" :total-visible="7" @input="onPageChange"></v-pagination>
			</div>
		</template>
    </v-data-table>
	<v-dialog v-model="showmessage">
		<v-toolbar dark color="warning" dense>
			<v-toolbar-title class="white--text">{{ message.title }}</v-toolbar-title>
		</v-toolbar>
		<v-card tile>
			<v-card-text color="red" v-html="message.msg"/>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="blue" text @click="onMessageClose()">Ok</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-overlay absolute :value="loading">
		<!--<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>-->
	</v-overlay>
    <GenericForm v-if="edit" :modulData="modulData" @cancelled="editCancelled()" @submitted="editSubmitted()" />
    <ConfirmDialog v-if="confirmDelete" :confirm="confirm" @cancel="onDeleteCancel()" @confirm="onDeleteConfirm()" />
    <ConfirmDialog v-if="confirmCopy" :confirm="confirm" @cancel="onCopyCancel()" @confirm="onCopyConfirm()" />
	<Selector v-if="selector" :modulData="modulData" @submit="onSelectorSubmit($event)" @cancel="onSelectorSubmit($event)" />
	</v-container>
</template>
<script>
import mixins from './helpers'
import GenericForm from './GenericForm'
import ConfirmDialog from './components/ConfirmDialog'
import Selector from './components/Selector'
export default {
	name: 'GenericSubList',
	mixins: [mixins],
	components: {
		GenericForm, ConfirmDialog, Selector,
	},
	props: {
		modulData: {
			type: Object,
			required: true,
			default: null,
		},
	},
	data: () => ({
		loading: false,
		message: {},
		showmessage: false,
		page: 1,
		pages: 1,
		perPage: 10,
		sortBy: 'id',
		sortChangeTime: null,
		sortDesc: true,
		filter: '',
		cfgTable: {},
		cfgRefTable: {},
		cfgLists: [],
		items: [],
		confirm: {},
		confirmDelete: false,
		itemToDelete: {},
		confirmCopy: false,
		itemToCopy: {},
		selector: false,
		//item: {},
		edit: false,
    }),
	computed: {
		filteredItems: function () {
			let self = this
			if(!self.items.length) {return []}
			if(!self.searchQuery || self.searchQuery.length < 3) {
				return self.items
			} else {
				return self.items.filter(function (item) {
					let searchRegex = new RegExp(self.searchQuery, 'i')
					return searchRegex.test(item.name)
				})
			}
		},
		tablename() {
			return this.modulData.meta.subtable
		},
	},
	methods: {
		customSort: function(items, index, isDesc) {
			return items;
		},
		async getData() {
            this.loading = true
			const param = {
				tablename: this.modulData.meta.subtable,
				parentref: this.modulData.meta.refcol,
				parentid: this.modulData.params.id,
				page: this.page,
				sortBy: this.sortBy,
				sortDesc: (this.sortDesc ? 'desc' : 'asc'),
				filter: this.filter || '',
			}
			//console.log('param:', JSON.stringify(param))
            try {
                await this.$store.dispatch('generic/getItems', param)
                const result = this.$store.getters['generic/getItems']( param )
                this.items = result.data
				this.page = result.current_page
				this.pages = result.last_page
				this.perPage = result.per_page
            } catch (error) {
                console.error(error)
                this.message.title = error.name
                this.message.msg = '<code>' + JSON.stringify(error.message).substring(0, 200) + '</code>'
                this.showmessage = true
            } finally {
                this.loading = false
            }
		},
		async delItem(item) {
            this.loading = true
			const param = {
				tablename: this.modulData.meta.subtable,
				data: item,
			}
            try {
                await this.$store.dispatch('generic/delItem', param)
				//console.log('deleted')
				this.getData()
            } catch (error) {
                console.error(error)
                this.message.title = error.name
                this.message.msg = '<code>' + JSON.stringify(error.message).substring(0, 200) + '</code>'
                this.showmessage = true
            } finally {
                this.loading = false
            }
		},
		async copyItem(item) {
            this.loading = true
			const param = {
				tablename: this.modulData.meta.subtable,
				data: item,
			}
            try {
                const response = await this.$store.dispatch('generic/copyItem', param)
				//console.log('response:', response)
				if(response.data.result == 'error') {
					this.message.title = 'Fehler'
					this.message.msg = '<code>' + JSON.stringify(response.data.message).substring(0, 200) + '</code>'
					this.showmessage = true
				}
				this.getData()
            } catch (error) {
                console.error(error)
                this.message.title = error.name
                this.message.msg = '<code>' + JSON.stringify(error.message).substring(0, 200) + '</code>'
                this.showmessage = true
            } finally {
                this.loading = false
            }
		},
		getCfgs() {
			let param = {
				table_name: this.modulData.meta.subtable,
				reftable: this.modulData.meta.tablename,
			}
			if(this.reftable == 'none') { param.reftable = this.tablename }
			this.cfgTable = this.$store.getters['core/getCfgTable'](param)
			this.cfgLists = this.$store.getters['core/getCfgLists'](param)
			this.cfgRefTable = this.$store.getters['core/getCfgRefTable'](param)
			//this.cfgLists.push({ text: 'Open', value: 'open', align: 'center', sortable: false, width: 25, })
			this.cfgLists.push({ text: 'Action', value: 'action', align: 'center', sortable: false, width: '150px', class: 'blue-grey darken-4', })
		},
		onSearch () {
			if(this.filter && this.filter.length < 3) return
			//console.log('FILTER:', this.filter)
			this.page = 1
			this.getData()
		},
		onSearchClear () {
			this.filter = ''
			this.page = 1
			this.getData()
		},
		onPageChange () {
			this.getData()
		},
		onPrintItem (id) {
			const url = new URL(window.location.origin)
			const baseURL = url.protocol + '//' + url.hostname
			const path = baseURL + '/' + this.cfgTable.model_name + '/' + id + '/print'
			window.open(path, "_blank")
		},
		onEditItem (id = null) {
			if(id && id >= 0) {
				const item = Object.assign({}, this.filteredItems.find(x => x.id === id))
				this.modulData.meta.model = item
			} else {
				const item = {}
				item[this.modulData.meta.refcol] = this.modulData.params.id
				item[this.modulData.name] = this.modulData.meta.item
				this.modulData.meta.model = item
			}
			this.edit = true
		},
		onDeleteItem (id) {
			this.itemToDelete = Object.assign({}, this.filteredItems.find(x => x.id === id))
			this.confirm.width = '400px'
			this.confirm.color = 'orange'
			this.confirm.title = 'Datensatz Löschen'
			this.confirm.msg = '<p>&nbsp;</p>'
			this.confirm.msg += '<p>Soll der Datensatz wirlich gelöscht werden?</p>'
			this.confirm.msg += '<p>' + this.itemToDelete.name + '</p>'
			this.confirm.cancel = 'Nein'
			this.confirm.confirm = 'Ja - Löschen'
			this.confirmDelete = true
		},
		onDeleteConfirm () {
			this.delItem(this.itemToDelete)
			this.itemToDelete = {}
			this.confirmDelete = false
		},
		onDeleteCancel () {
			this.itemToDelete = {}
			this.confirmDelete = false
		},
		onCopyItem (id) {
			this.itemToCopy = Object.assign({}, this.filteredItems.find(x => x.id === id))
			this.confirm.width = '400px'
			this.confirm.color = 'teal'
			this.confirm.title = 'Datensatz Kopieren'
			this.confirm.msg = '<p>&nbsp;</p>'
			this.confirm.msg += '<p>Soll der Datensatz wirlich auf die Gruppe kopiert werden?</p>'
			this.confirm.msg += '<p>' + this.itemToCopy.name + '</p>'
			this.confirm.cancel = 'Nein'
			this.confirm.confirm = 'Ja - Kopieren'
			this.confirmCopy = true
		},
		onCopyConfirm () {
			this.copyItem(this.itemToCopy)
			this.itemToCopy = {}
			this.confirmCopy = false
		},
		onCopyCancel () {
			this.itemToCopy = {}
			this.confirmCopy = false
		},
		editCancelled () {
			this.edit = false
			this.snack = {active: true, type: 'warning', text: 'cancelled'}
		},
		editSubmitted() {
			this.getData()
			this.edit = false
			this.snack = {active: true, type: 'success', text: 'saved'}
			this.$emit('updated')
		},
		onSortChange () {
			this.$nextTick(() => {
				this.getData()
			})
		},
		onRowClick(e) {
			//console.log('clicked:', e)
			const item = e
			this.$router.push({ name: this.cfgTable.model_name, params: { id: item.id } })
		},
		onMessageClose() {
			this.message = {}
			this.showmessage = false			
		},
        onCopyItemTo(id) {
			if (this.cfgRefTable.selector) {
				this.itemToCopy = Object.assign({}, this.filteredItems.find(x => x.id === id))
				this.modulData.meta.model = this.itemToCopy
				this.modulData.meta.seltable = this.cfgRefTable.selector
				this.selector = true
			}
        },
        async onSelectorSubmit(newItems) {
            if(!Array.isArray(newItems)) {
				this.selector = false
				return false
			}
			console.log(newItems)
			this.loading = true
			const item = this.itemToCopy
			item.targets = newItems
			const param = {
				tablename: this.modulData.meta.subtable,
				data: item,
			}
			try {
				const response = await this.$store.dispatch('generic/copyItemTo', param)
				//console.log('response:', response)
				if(response.data.result == 'error') {
					this.message.title = 'Fehler'
					this.message.msg = '<code>' + JSON.stringify(response.data.message).substring(0, 200) + '</code>'
					this.showmessage = true
				} else if(response.data.result == 'success') {
					this.message.title = 'Ergebnis'
					this.message.msg = '<code>' + JSON.stringify(response.data.message).substring(0, 200) + '</code>'
					this.showmessage = true
				}
				this.getData()
			} catch (error) {
				console.error(error)
				this.message.title = error.name
				this.message.msg = '<code>' + JSON.stringify(error.message).substring(0, 200) + '</code>'
				this.showmessage = true
			} finally {
				this.loading = false
			}
            this.selector = false
        },
	},
	mounted() {
		this.getCfgs()
		this.getData()
	},
	watch: {
		sortBy () {
			if(Date.now() - this.sortChangeTime > 50) setTimeout(this.onSortChange (), 50)
			this.sortChangeTime = Date.now()
		},
		sortDesc () {
			if(Date.now() - this.sortChangeTime > 50) setTimeout(this.onSortChange (), 50)
			this.sortChangeTime = Date.now()
		},
	},
};
</script>
<style scoped>
.selected {
    background-color: red
}
.table-cursor >>> tbody tr:hover {
	cursor: pointer;
}
.text-color-red {
	color:#F44336;
	font-weight: bold;
}
.v-data-table >>> tbody tr:hover {
	/*background: transparent !important;*/
  	background: #3E5059 !important;
}
</style>